module.exports = __webpack_public_path__ + "img/TEASER_RICARICABILE_768X176.8682635b.jpg";